function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.44 10.004L7.205 14.09a.632.632 0 00-.21.486.68.68 0 00.224.486.705.705 0 00.505.209c.191 0 .36-.07.504-.209l4.439-4.266a1.109 1.109 0 00.346-.792 1.108 1.108 0 00-.346-.792L8.227 4.93a.689.689 0 00-.512-.202.735.735 0 00-.511.216.654.654 0 000 .973l4.237 4.086z",
  fill: "#818793"
});

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref);
};

export default SvgArrow;